import React from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
import { CTAButton } from './ui/CTAButton';
export function OfferBlock() {
  return <SectionWrapper id="offer-block" className="bg-white" data-id="element-77">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-78">
        <div className="bg-brand-dark rounded-3xl p-8 md:p-12 text-center text-white shadow-2xl relative overflow-hidden" data-id="element-79">
          {/* Background accent */}
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-brand-teal via-brand-amber to-brand-teal" data-id="element-80"></div>

          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-81">
            Recupera el control de tu cuerpo hoy mismo.
          </h2>

          <div className="mb-8" data-id="element-82">
            <span className="inline-block bg-red-500 text-white text-sm font-bold px-3 py-1 rounded-full mb-4" data-id="element-83">
              -68% DESCUENTO
            </span>
            <div className="flex items-center justify-center gap-4" data-id="element-84">
              <span className="text-gray-400 line-through text-2xl font-medium" data-id="element-85">
                $19.99
              </span>
              <span className="text-5xl md:text-6xl font-extrabold text-brand-amber" data-id="element-86">
                $6.39
              </span>
            </div>
          </div>

          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-87">
            Recibe el sistema completo de Inflamación Zero 48h y olvídate de la
            pesadez para siempre. Es menos de lo que cuesta una cena fuera, pero
            con beneficios que sentirás cada vez que te mires al espejo.
          </p>

          <CTAButton className="max-w-lg" data-id="element-88" />
        </div>
      </div>
    </SectionWrapper>;
}